import React, { useEffect, useState } from 'react';
import createBonusUI from '@voogo/bonus-ui';
import '@voogo/bonus-ui/style.css';
import api from '../services/api';
const { CampaignManager, LegacyBonusList } = createBonusUI(React);
export default function BonusCampaigns() {
  const [legacy,setLegacy]=useState([]),[error,setError]=useState(false);
  const load=async()=>{try{const r=await api.get('/admin/bonuses');setLegacy((r.data.bonuses||[]).map(b=>({...b,partner_name:r.data.partners?.find(p=>p.id===b.partner_id)?.company_name})));setError(false);}catch(e){setError(true);}};
  useEffect(()=>{load();},[]);
  return <><CampaignManager api={api} scope="admin"/>
    {error?<p role="alert">Wochenboni konnten nicht geladen werden. <button onClick={load}>Erneut laden</button></p>:<LegacyBonusList api={api} rows={legacy} onChanged={load}/>}</>;
}
